import React from 'react';
import _ from 'lodash';
import SimpleDialog from 'components/Dialog/SimpleDialog';
import { withState, compose } from 'recompose';
import { Tabs, Tab, RaisedButton } from 'material-ui';
import MenuEditor from './MenuEditor';
import Chip from 'material-ui/Chip';
import MagentoCategories from 'components/magento/MagentoCategories';
import { initialMenuState } from 'helpers/initialState';
import { removeItemArrayByIndex } from 'helpers/arrayHelpers';

const styles = {
  custom: {
    overflowY: 'scroll',
    height: 400,
  },
};

const createCustomMenuFromMagento = ({
  id,
  name,
}) => ({
  name: _.isObject(name) ? { ...name } : { en: name, th: name },
  title: _.isObject(name) ? `${name.en} / ${name.th}` : `${name} / ${name}`,
  subtitle: 'magento',
  url: `/category/${_.isObject(name) ? name.en : name}?category=${id}`,
  target: '_self',
  image: '',
  imageLink: `/category/${_.isObject(name) ? name.en : name}?category=${id}`,
  imageTarget: '_self',
});

const MenuAddDialog = ({
  onClose,
  open,
  onSubmit,
  activeTab,
  setActiveTab,
  customMenu,
  updateCustomMenu,
  menus,
  updateMenus,
}) => {
  const handleSubmitAction = () => {
    onSubmit(menus);
    return updateMenus([]);
  };

  return (
    <SimpleDialog onClose={onClose} open={open} onSubmit={() => handleSubmitAction()} title="Add New Menu">
      <div style={menus.length > 0 ? { marginBottom: '80px' } : {}}>
        <Tabs
          value={activeTab}
          onChange={value => setActiveTab(value)}
        >
          <Tab label="Custom Menu" value="custom">
            <div style={styles.custom}>
              <MenuEditor menu={customMenu} onChange={updateCustomMenu} />
              <RaisedButton
                label="+ OK"
                style={{ marginLeft: 30 }}
                primary
                onClick={() => {
                  updateMenus([...menus, customMenu]);
                  return updateCustomMenu(initialMenuState);
                }}
              />
            </div>
          </Tab>
          <Tab label="Magento" value="magento">
            <div style={{ height: 500, overflow: 'auto', width: 400, margin: 'auto' }}>
              <MagentoCategories
                onClick={(menu) => {
                  updateMenus(
                    [
                      ...menus,
                      createCustomMenuFromMagento(menu),
                    ],
                  );
                }}
              />
            </div>
          </Tab>
        </Tabs>
        {
          menus.length > 0 &&
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              position: 'fixed',
              bottom: 50,
              left: 0,
              right: 0,
              padding: 20,
              background: '#ffffff',
              border: '1px solid #e8e8e8',
              zIndex: 100,
            }}
          >
            {menus.map((menu, i) => (
              <Chip
                key={i}
                onRequestDelete={() => updateMenus(removeItemArrayByIndex(menus, i))}
                style={{ marginRight: 10, marginBottom: 10 }}
              >
                {menu.title}
              </Chip>
            ))}
          </div>
        }
      </div>
    </SimpleDialog>);
};


MenuAddDialog.propTypes = {};
MenuAddDialog.defaultProps = {};

export default compose(
  withState('activeTab', 'setActiveTab', 'custom'),
  withState('menus', 'updateMenus', []),
  withState('customMenu', 'updateCustomMenu', initialMenuState),
)(MenuAddDialog);



// WEBPACK FOOTER //
// ./src/pages/Menus/children/MenuAddDialog.js